import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Input } from 'reactstrap'

const Footer = ({ dispatch, ...props }) => {
  const auth = useSelector((state) => state.auth)
  let language = props.language || {}

  return (
    <div className='container-fluid'>
      <div className='row checklist-footer-row'>
        <div className='col-12'>
          <label className='mr-2'>
            {language.manager_report
              ? language.manager_report.manager_name
              : null}
          </label>
          <Input
            type='text'
            defaultValue={`${auth?.user?.first_name} ${auth?.user?.last_name}`}
            onChange={(event) => {
              dispatch(props.onChangeSection('managerName', event.target.value))
            }}
          />
        </div>
      </div>
      <div className='row checklist-footer-row'>
        <div className='col-12'>
          <p className='checklist-approve'>
            {language.manager_report
              ? language.manager_report.checklist_successful_statement
              : null}
          </p>
        </div>
      </div>
      <div className='row checklist-footer-row'>
        <div className='col-12'>
          <label style={{ fontSize: '12px' }}>{props.requestStatus}</label>
          <Link
            to={`/manager-reports/employee/${props.userId}`}
            onClick={() => dispatch(props.saveChecklist())}
            className='btn btn-info'
            style={{ marginLeft: '4px', marginRight: '4px' }}
          >
            {language.general ? language.general.save : null}
          </Link>
          <button
            onClick={() => dispatch(props.submitChecklist())}
            className='btn btn-info'
          >
            {language.general ? language.general.submit : null}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Footer
